import { Field, FieldArray } from 'redux-form';
import PublicDatePicker from '../components/PublicDatePicker/PublicDatePicker';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';
import { PublicCheckbox } from '../../../common/components';
import React from 'react';
import Select from 'react-select';
import Directors from '../components/Directors/Directors';
import Address from '../components/Address/Address';
import {
  Input,
  NameFields,
  FormGroupBooleanButtonGroup,
  FormGroupInput,
  SelectMenuFormGroup,
} from '../../../common/form/components/components';
import { required, email, length, acceptance } from 'redux-form-validators';
import {
  ValidationError,
  ErrorMessage,
} from '../components/StyledComponents/StyledComponents';
import styled from 'styled-components';

const isRequired = required({ message: 'Field is Required' });
const isEmail = email({ message: 'Valid Email Address is Required' });
const isAccepted = acceptance({ message: 'Please Agree' });
const minDirectors = length({ min: 1, message: 'At least one director is required' });

const ValidationState = ({ showError, children }) => {
  return <ValidationError showError={showError}>{children}</ValidationError>;
};

const LabelText = styled(ControlLabel)`
    font-weight: normal;
    font-size: 16px;
`;

const BusinessTypeSelect = ({ meta, input, labelSize, colSize, label, options }) => {
  const showError = meta.touched && meta.error;
  const onChange = (option) => {
    input.onChange(option && option.value ? option.value : '');
  };
  return (
    <FormGroup key={input.name}>
      <Col sm={labelSize}>
        <LabelText>Business Type:</LabelText>
      </Col>
      <Col sm={colSize}>
        <ValidationState showError={showError}>
          <Select
            name={input.name}
            key={input.name}
            value={options.find((option) => option.value === input.value)}
            //component={Select}
            onChange={onChange}
            options={options}
            label={label}
            labelSize={labelSize}
          />
          {showError && meta.error && <ErrorMessage> {meta.error}</ErrorMessage>}
        </ValidationState>
      </Col>
    </FormGroup>
  );
};

const NameInput = ({ labelSize, colSize, label, input, required }) => {
  return (
    <FormGroup key={input.name}>
      <Col sm={labelSize}>
        <LabelText>{label} </LabelText>
      </Col>
      <Col sm={colSize}>
        <Field
          name={input.name}
          component={NameFields}
          incTitle={true}
          isChild={false}
          required={required}
        />
      </Col>
    </FormGroup>
  );
};

const InputWithValidation = ({ input, meta, addOnBefore }) => {
  const showError = meta.touched && meta.error;
  return (
    <FormGroup key={input.name}>
      <Col sm={12}>
        <ValidationState showError={showError}>
          <Field name={input.name} component={Input} addOnBefore={addOnBefore} />
          {meta.touched && !!meta.error && <ErrorMessage>{meta.error}</ErrorMessage>}
        </ValidationState>
      </Col>
    </FormGroup>
  );
};

const InputArray = ({ numberOfInputs, input, required }) => {
  const inputs = [...Array(numberOfInputs).keys()];
  return (
    <>
      {inputs.map((itemNumber) => (
        <Field
          key={`${input.name}.${itemNumber}`}
          name={`${input.name}.${itemNumber}`}
          component={InputWithValidation}
          validate={required ? isRequired : undefined}
          addOnBefore={itemNumber + 1}
        />
      ))}
    </>
  );
};

const InputArrayFormGroup = ({
  label,
  labelSize,
  colSize,
  input,
  required,
  numberOfInputs,
}) => {
  return (
    <FormGroup key={input.name}>
      <Col sm={labelSize}>
        <ControlLabel>{label} </ControlLabel>
      </Col>
      <Col sm={colSize}>
        <InputArray input={input} required={required} numberOfInputs={numberOfInputs} />
      </Col>
    </FormGroup>
  );
};

const ComponentHelper = ({
  contentFields,
  labelSize,
  colSize,
  formValues,
  updateAddress,
  removeDirectors,
}) => {
  const updateAddr = (name) => (address) => {
    updateAddress(name, address);
  };

  return (
    <>
      {contentFields.map((field) => {
        switch (field.type) {
          case 'radio': {
            if (field.selectType === 'brokerBusinessType') {
              return (
                <Field
                  key={field.name}
                  name={field.name}
                  component={BusinessTypeSelect}
                  options={field.options}
                  label={field.label}
                  labelSize={3}
                  colSize={colSize}
                  validate={field.required ? isRequired : undefined}
                />
              );
            }
            break;
          }
          case 'currency': {
            return (
              <Field
                key={field.name}
                name={field.name}
                labelSize={labelSize}
                colSize={field.colSize || colSize}
                component={FormGroupInput}
                addOnBefore={'£'}
                cleaveOptions={{ numeral: true }}
                label={field.label}
                validate={field.required ? isRequired : undefined}
              />
            );
          }

          case 'email': {
            return (
              <Field
                key={field.name}
                name={field.name}
                labelSize={field.labelSize || labelSize}
                colSize={colSize}
                //fieldSize={4}
                component={FormGroupInput}
                label={field.label}
                validate={field.required ? isEmail : undefined}
              />
            );
          }
          case 'website': {
            return (
              <Field
                key={field.name}
                name={field.name}
                labelSize={labelSize}
                colSize={colSize}
                //fieldSize={4}
                component={FormGroupInput}
                label={field.label}
                validate={field.required ? isRequired : undefined}
              />
            );
          }
          case 'input': {
            return (
              <Field
                key={field.name}
                name={field.name}
                labelSize={field.labelSize || labelSize}
                colSize={colSize}
                // fieldSize={4}
                component={FormGroupInput}
                label={field.label}
                validate={field.required ? isRequired : undefined}
              />
            );
          }

          case 'number': {
            return (
              <Field
                key={field.name}
                name={field.name}
                labelSize={labelSize}
                colSize={field.colSize || colSize}
                type={'cleave'}
                cleaveOptions={{ numeral: true }}
                // fieldSize={4}
                component={FormGroupInput}
                label={field.label}
                validate={field.required ? isRequired : undefined}
              />
            );
          }
          case 'date': {
            return (
              <FormGroup key={field.name}>
                <Col sm={field.labelSize || labelSize}>
                  <LabelText>{field.label}</LabelText>
                </Col>
                <Col sm={5}>
                  <Field
                    name={field.name}
                    key={field.name}
                    labelSize={labelSize}
                    component={PublicDatePicker}
                    label={field.label}
                    validate={field.required ? isRequired : undefined}
                  />
                </Col>
              </FormGroup>
            );
          }
          case 'name': {
            return (
              <Field
                key={field.name}
                label={field.label}
                name={field.name}
                labelSize={labelSize}
                colSize={colSize}
                required={field.required}
                component={NameInput}
              />
            );
          }
          case 'address': {
            return (
              <Field
                key={field.name}
                component={Address}
                name={field.name}
                labelSize={3}
                colSize={9}
                label={field.label}
                updateAddress={updateAddr(field.name)}
                required={field.required}
              />
            );
          }

          case 'select': {
            return (
              <Field
                key={field.name}
                name={field.name}
                source={field.source}
                component={SelectMenuFormGroup}
                labelSize={labelSize}
                label={field.label}
                colSize={colSize}
                validate={required ? isRequired : undefined}
              />
            );
          }
          case 'question': {
            return (
              <Field
                key={field.name}
                name={field.name}
                component={FormGroupBooleanButtonGroup}
                options={field.options}
                label={field.label}
                labelSize={field.labelSize || labelSize}
                colSize={field.colSize || colSize}
                validate={field.required ? isRequired : undefined}
              />
            );
          }
          case 'directorsArray': {
            return (
              <FieldArray
                key={field.name}
                name={field.name}
                formValues={formValues}
                removeDirectors={removeDirectors}
                component={Directors}
                validate={minDirectors}
              />
            );
          }

          case 'tickBox': {
            return (
              <FormGroup key={field.name}>
                <Col sm={12}>
                  <Field
                    name={field.name}
                    label={field.label}
                    formValues={formValues}
                    component={PublicCheckbox}
                    validate={field.required ? isAccepted : undefined}
                  />
                </Col>
              </FormGroup>
            );
          }
          case 'inputArray': {
            return (
              <Field
                key={field.name}
                name={field.name}
                label={field.label}
                component={InputArrayFormGroup}
                required={field.required}
                numberOfInputs={field.numberOfInputs}
                labelSize={labelSize}
                colSize={field.colSize || colSize}
              />
            );
          }
        }
      })}
    </>
  );
};

export default ComponentHelper;
